const color = [
  "primary",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "neutral"
] as const

const variant = [
  "solid",
  "outline",
  "soft",
  "subtle",
  "ghost",
  "link"
] as const

const size = [
  "xs",
  "sm",
  "md",
  "lg",
  "xl"
] as const

export default {
  "slots": {
    "base": [
      "tw:rounded-md tw:font-medium tw:inline-flex tw:items-center tw:disabled:cursor-not-allowed tw:aria-disabled:cursor-not-allowed tw:disabled:opacity-75 tw:aria-disabled:opacity-75",
      "tw:transition-colors"
    ],
    "label": "tw:truncate",
    "leadingIcon": "tw:shrink-0",
    "leadingAvatar": "tw:shrink-0",
    "leadingAvatarSize": "",
    "trailingIcon": "tw:shrink-0"
  },
  "variants": {
    "fieldGroup": {
      "horizontal": "tw:not-only:first:rounded-e-none tw:not-only:last:rounded-s-none tw:not-last:not-first:rounded-none tw:focus-visible:z-[1]",
      "vertical": "tw:not-only:first:rounded-b-none tw:not-only:last:rounded-t-none tw:not-last:not-first:rounded-none tw:focus-visible:z-[1]"
    },
    "color": {
      "primary": "",
      "secondary": "",
      "success": "",
      "info": "",
      "warning": "",
      "error": "",
      "neutral": ""
    },
    "variant": {
      "solid": "",
      "outline": "",
      "soft": "",
      "subtle": "",
      "ghost": "",
      "link": ""
    },
    "size": {
      "xs": {
        "base": "tw:px-2 tw:py-1 tw:text-xs tw:gap-1",
        "leadingIcon": "tw:size-4",
        "leadingAvatarSize": "3xs",
        "trailingIcon": "tw:size-4"
      },
      "sm": {
        "base": "tw:px-2.5 tw:py-1.5 tw:text-xs tw:gap-1.5",
        "leadingIcon": "tw:size-4",
        "leadingAvatarSize": "3xs",
        "trailingIcon": "tw:size-4"
      },
      "md": {
        "base": "tw:px-2.5 tw:py-1.5 tw:text-sm tw:gap-1.5",
        "leadingIcon": "tw:size-5",
        "leadingAvatarSize": "2xs",
        "trailingIcon": "tw:size-5"
      },
      "lg": {
        "base": "tw:px-3 tw:py-2 tw:text-sm tw:gap-2",
        "leadingIcon": "tw:size-5",
        "leadingAvatarSize": "2xs",
        "trailingIcon": "tw:size-5"
      },
      "xl": {
        "base": "tw:px-3 tw:py-2 tw:text-base tw:gap-2",
        "leadingIcon": "tw:size-6",
        "leadingAvatarSize": "xs",
        "trailingIcon": "tw:size-6"
      }
    },
    "block": {
      "true": {
        "base": "tw:w-full tw:justify-center",
        "trailingIcon": "tw:ms-auto"
      }
    },
    "square": {
      "true": ""
    },
    "leading": {
      "true": ""
    },
    "trailing": {
      "true": ""
    },
    "loading": {
      "true": ""
    },
    "active": {
      "true": {
        "base": ""
      },
      "false": {
        "base": ""
      }
    }
  },
  "compoundVariants": [
    {
      "color": "primary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "tw:text-inverted tw:bg-primary tw:hover:bg-primary/75 tw:active:bg-primary/75 tw:disabled:bg-primary tw:aria-disabled:bg-primary tw:focus-visible:outline-2 tw:focus-visible:outline-offset-2 tw:focus-visible:outline-primary"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "tw:text-inverted tw:bg-secondary tw:hover:bg-secondary/75 tw:active:bg-secondary/75 tw:disabled:bg-secondary tw:aria-disabled:bg-secondary tw:focus-visible:outline-2 tw:focus-visible:outline-offset-2 tw:focus-visible:outline-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "tw:text-inverted tw:bg-success tw:hover:bg-success/75 tw:active:bg-success/75 tw:disabled:bg-success tw:aria-disabled:bg-success tw:focus-visible:outline-2 tw:focus-visible:outline-offset-2 tw:focus-visible:outline-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "tw:text-inverted tw:bg-info tw:hover:bg-info/75 tw:active:bg-info/75 tw:disabled:bg-info tw:aria-disabled:bg-info tw:focus-visible:outline-2 tw:focus-visible:outline-offset-2 tw:focus-visible:outline-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "tw:text-inverted tw:bg-warning tw:hover:bg-warning/75 tw:active:bg-warning/75 tw:disabled:bg-warning tw:aria-disabled:bg-warning tw:focus-visible:outline-2 tw:focus-visible:outline-offset-2 tw:focus-visible:outline-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "tw:text-inverted tw:bg-error tw:hover:bg-error/75 tw:active:bg-error/75 tw:disabled:bg-error tw:aria-disabled:bg-error tw:focus-visible:outline-2 tw:focus-visible:outline-offset-2 tw:focus-visible:outline-error"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "tw:ring tw:ring-inset tw:ring-primary/50 tw:text-primary tw:hover:bg-primary/10 tw:active:bg-primary/10 tw:disabled:bg-transparent tw:aria-disabled:bg-transparent tw:dark:disabled:bg-transparent tw:dark:aria-disabled:bg-transparent tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-primary"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "tw:ring tw:ring-inset tw:ring-secondary/50 tw:text-secondary tw:hover:bg-secondary/10 tw:active:bg-secondary/10 tw:disabled:bg-transparent tw:aria-disabled:bg-transparent tw:dark:disabled:bg-transparent tw:dark:aria-disabled:bg-transparent tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "tw:ring tw:ring-inset tw:ring-success/50 tw:text-success tw:hover:bg-success/10 tw:active:bg-success/10 tw:disabled:bg-transparent tw:aria-disabled:bg-transparent tw:dark:disabled:bg-transparent tw:dark:aria-disabled:bg-transparent tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "tw:ring tw:ring-inset tw:ring-info/50 tw:text-info tw:hover:bg-info/10 tw:active:bg-info/10 tw:disabled:bg-transparent tw:aria-disabled:bg-transparent tw:dark:disabled:bg-transparent tw:dark:aria-disabled:bg-transparent tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "tw:ring tw:ring-inset tw:ring-warning/50 tw:text-warning tw:hover:bg-warning/10 tw:active:bg-warning/10 tw:disabled:bg-transparent tw:aria-disabled:bg-transparent tw:dark:disabled:bg-transparent tw:dark:aria-disabled:bg-transparent tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "tw:ring tw:ring-inset tw:ring-error/50 tw:text-error tw:hover:bg-error/10 tw:active:bg-error/10 tw:disabled:bg-transparent tw:aria-disabled:bg-transparent tw:dark:disabled:bg-transparent tw:dark:aria-disabled:bg-transparent tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-error"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "tw:text-primary tw:bg-primary/10 tw:hover:bg-primary/15 tw:active:bg-primary/15 tw:focus:outline-none tw:focus-visible:bg-primary/15 tw:disabled:bg-primary/10 tw:aria-disabled:bg-primary/10"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "tw:text-secondary tw:bg-secondary/10 tw:hover:bg-secondary/15 tw:active:bg-secondary/15 tw:focus:outline-none tw:focus-visible:bg-secondary/15 tw:disabled:bg-secondary/10 tw:aria-disabled:bg-secondary/10"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "tw:text-success tw:bg-success/10 tw:hover:bg-success/15 tw:active:bg-success/15 tw:focus:outline-none tw:focus-visible:bg-success/15 tw:disabled:bg-success/10 tw:aria-disabled:bg-success/10"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "tw:text-info tw:bg-info/10 tw:hover:bg-info/15 tw:active:bg-info/15 tw:focus:outline-none tw:focus-visible:bg-info/15 tw:disabled:bg-info/10 tw:aria-disabled:bg-info/10"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "tw:text-warning tw:bg-warning/10 tw:hover:bg-warning/15 tw:active:bg-warning/15 tw:focus:outline-none tw:focus-visible:bg-warning/15 tw:disabled:bg-warning/10 tw:aria-disabled:bg-warning/10"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "tw:text-error tw:bg-error/10 tw:hover:bg-error/15 tw:active:bg-error/15 tw:focus:outline-none tw:focus-visible:bg-error/15 tw:disabled:bg-error/10 tw:aria-disabled:bg-error/10"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "tw:text-primary tw:ring tw:ring-inset tw:ring-primary/25 tw:bg-primary/10 tw:hover:bg-primary/15 tw:active:bg-primary/15 tw:disabled:bg-primary/10 tw:aria-disabled:bg-primary/10 tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-primary"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "tw:text-secondary tw:ring tw:ring-inset tw:ring-secondary/25 tw:bg-secondary/10 tw:hover:bg-secondary/15 tw:active:bg-secondary/15 tw:disabled:bg-secondary/10 tw:aria-disabled:bg-secondary/10 tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "tw:text-success tw:ring tw:ring-inset tw:ring-success/25 tw:bg-success/10 tw:hover:bg-success/15 tw:active:bg-success/15 tw:disabled:bg-success/10 tw:aria-disabled:bg-success/10 tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "tw:text-info tw:ring tw:ring-inset tw:ring-info/25 tw:bg-info/10 tw:hover:bg-info/15 tw:active:bg-info/15 tw:disabled:bg-info/10 tw:aria-disabled:bg-info/10 tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "tw:text-warning tw:ring tw:ring-inset tw:ring-warning/25 tw:bg-warning/10 tw:hover:bg-warning/15 tw:active:bg-warning/15 tw:disabled:bg-warning/10 tw:aria-disabled:bg-warning/10 tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "tw:text-error tw:ring tw:ring-inset tw:ring-error/25 tw:bg-error/10 tw:hover:bg-error/15 tw:active:bg-error/15 tw:disabled:bg-error/10 tw:aria-disabled:bg-error/10 tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-error"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "tw:text-primary tw:hover:bg-primary/10 tw:active:bg-primary/10 tw:focus:outline-none tw:focus-visible:bg-primary/10 tw:disabled:bg-transparent tw:aria-disabled:bg-transparent tw:dark:disabled:bg-transparent tw:dark:aria-disabled:bg-transparent"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "tw:text-secondary tw:hover:bg-secondary/10 tw:active:bg-secondary/10 tw:focus:outline-none tw:focus-visible:bg-secondary/10 tw:disabled:bg-transparent tw:aria-disabled:bg-transparent tw:dark:disabled:bg-transparent tw:dark:aria-disabled:bg-transparent"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "tw:text-success tw:hover:bg-success/10 tw:active:bg-success/10 tw:focus:outline-none tw:focus-visible:bg-success/10 tw:disabled:bg-transparent tw:aria-disabled:bg-transparent tw:dark:disabled:bg-transparent tw:dark:aria-disabled:bg-transparent"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "tw:text-info tw:hover:bg-info/10 tw:active:bg-info/10 tw:focus:outline-none tw:focus-visible:bg-info/10 tw:disabled:bg-transparent tw:aria-disabled:bg-transparent tw:dark:disabled:bg-transparent tw:dark:aria-disabled:bg-transparent"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "tw:text-warning tw:hover:bg-warning/10 tw:active:bg-warning/10 tw:focus:outline-none tw:focus-visible:bg-warning/10 tw:disabled:bg-transparent tw:aria-disabled:bg-transparent tw:dark:disabled:bg-transparent tw:dark:aria-disabled:bg-transparent"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "tw:text-error tw:hover:bg-error/10 tw:active:bg-error/10 tw:focus:outline-none tw:focus-visible:bg-error/10 tw:disabled:bg-transparent tw:aria-disabled:bg-transparent tw:dark:disabled:bg-transparent tw:dark:aria-disabled:bg-transparent"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "tw:text-primary tw:hover:text-primary/75 tw:active:text-primary/75 tw:disabled:text-primary tw:aria-disabled:text-primary tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-inset tw:focus-visible:ring-primary"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "tw:text-secondary tw:hover:text-secondary/75 tw:active:text-secondary/75 tw:disabled:text-secondary tw:aria-disabled:text-secondary tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-inset tw:focus-visible:ring-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "tw:text-success tw:hover:text-success/75 tw:active:text-success/75 tw:disabled:text-success tw:aria-disabled:text-success tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-inset tw:focus-visible:ring-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "tw:text-info tw:hover:text-info/75 tw:active:text-info/75 tw:disabled:text-info tw:aria-disabled:text-info tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-inset tw:focus-visible:ring-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "tw:text-warning tw:hover:text-warning/75 tw:active:text-warning/75 tw:disabled:text-warning tw:aria-disabled:text-warning tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-inset tw:focus-visible:ring-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "tw:text-error tw:hover:text-error/75 tw:active:text-error/75 tw:disabled:text-error tw:aria-disabled:text-error tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-inset tw:focus-visible:ring-error"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "tw:text-inverted tw:bg-inverted tw:hover:bg-inverted/90 tw:active:bg-inverted/90 tw:disabled:bg-inverted tw:aria-disabled:bg-inverted tw:focus-visible:outline-2 tw:focus-visible:outline-offset-2 tw:focus-visible:outline-inverted"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "tw:ring tw:ring-inset tw:ring-accented tw:text-default tw:bg-default tw:hover:bg-elevated tw:active:bg-elevated tw:disabled:bg-default tw:aria-disabled:bg-default tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-inverted"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "tw:text-default tw:bg-elevated tw:hover:bg-accented/75 tw:active:bg-accented/75 tw:focus:outline-none tw:focus-visible:bg-accented/75 tw:disabled:bg-elevated tw:aria-disabled:bg-elevated"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "tw:ring tw:ring-inset tw:ring-accented tw:text-default tw:bg-elevated tw:hover:bg-accented/75 tw:active:bg-accented/75 tw:disabled:bg-elevated tw:aria-disabled:bg-elevated tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-inverted"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "tw:text-default tw:hover:bg-elevated tw:active:bg-elevated tw:focus:outline-none tw:focus-visible:bg-elevated tw:hover:disabled:bg-transparent tw:dark:hover:disabled:bg-transparent tw:hover:aria-disabled:bg-transparent tw:dark:hover:aria-disabled:bg-transparent"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "tw:text-muted tw:hover:text-default tw:active:text-default tw:disabled:text-muted tw:aria-disabled:text-muted tw:focus:outline-none tw:focus-visible:ring-inset tw:focus-visible:ring-2 tw:focus-visible:ring-inverted"
    },
    {
      "size": "xs" as typeof size[number],
      "square": true,
      "class": "tw:p-1"
    },
    {
      "size": "sm" as typeof size[number],
      "square": true,
      "class": "tw:p-1.5"
    },
    {
      "size": "md" as typeof size[number],
      "square": true,
      "class": "tw:p-1.5"
    },
    {
      "size": "lg" as typeof size[number],
      "square": true,
      "class": "tw:p-2"
    },
    {
      "size": "xl" as typeof size[number],
      "square": true,
      "class": "tw:p-2"
    },
    {
      "loading": true,
      "leading": true,
      "class": {
        "leadingIcon": "tw:animate-spin"
      }
    },
    {
      "loading": true,
      "leading": false,
      "trailing": true,
      "class": {
        "trailingIcon": "tw:animate-spin"
      }
    }
  ],
  "defaultVariants": {
    "color": "primary" as typeof color[number],
    "variant": "solid" as typeof variant[number],
    "size": "md" as typeof size[number]
  }
}